(() => {
  if (window.kleengentProductNavigationLoaded) return;
  window.kleengentProductNavigationLoaded = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-kg-product-navigation][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target) || event.target.closest('a')) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDropdowns = document.querySelectorAll('[data-kg-product-navigation][open]');
    openDropdowns.forEach((dropdown) => {
      const containedFocus = dropdown.contains(document.activeElement);
      dropdown.open = false;
      if (containedFocus) dropdown.querySelector('summary').focus();
    });
  });
})();
